import React from 'react';
import * as R from 'ramda';
import { Popconfirm, Checkbox, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import { validateBearerToken } from '../../common/api/validationAPI';
import Tool from '../../components/Tool';

const formItemLayout = {};

class ConnectionToolEditor extends React.Component {
  state = {
    confirmDirty: false,
  };

  handleSubmit = (e) => {
    const { form, onSubmit } = this.props;
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  validateBearerToken = (rule, value, callback) => {
    validateBearerToken(value)
      .then(() => {
        callback();
      })
      .catch((error) => {
        if (R.path(['response', 'data', 'status'], error) === 401) {
          callback('Invalid bearer token!');
        } else {
          callback('Unable to validate bearer token!');
        }
      })
    ;
  };

  render() {
    const { form, onBack, onDelete, connection, isNew } = this.props;
    const connectionData = connection || {};


    return (
      <Tool
        title="Connections"
        subTitle={connection ? 'Editing Connection' : 'New Connection'}
        onBack={onBack}
        actions={[
          connection && (
            <Popconfirm
              title="Are you sure delete this connection?"
              onConfirm={onDelete}
              okText="Yes"
              cancelText="No"
            >
              <Tool.Header.Action
                icon="delete"
              />
            </Popconfirm>
          ),
        ]}
        footer={(
          <div style={{ textAlign: 'right' }}>
            <Button ghost onClick={this.handleSubmit}>Save</Button>
          </div>
        )}
      >
        <Form onSubmit={this.handleSubmit} style={{ padding: '16px' }}>
          <Form.Item
            {...formItemLayout}
            label="Name"
          >
            {form.getFieldDecorator('name', {
              initialValue: connectionData.name,
              rules: [{
                required: true,
                message: 'Please input a connection name.',
              }],
            })(
              <Input type="text" maxLength="24" placeholder="Name your connection." />,
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label={(
              <span>
                <span>API Key&nbsp;</span>
                <Tooltip title="This is your Bearer Token supplied by Voicebase.">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            )}
          >
            {form.getFieldDecorator('bearerToken', {
              validateFirst: true,
              initialValue: connectionData.bearerToken,
              rules: [{
                required: true,
                message: 'Please input your API platform key.',
              }, {
                  validator: this.validateBearerToken,
                }],
            })(
              <Input type="text" placeholder="Enter a VB supplied API key." />,
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Description"
          >
            {form.getFieldDecorator('description', {
              validateFirst: true,
              initialValue: connectionData.description,
            })(
              <Input.TextArea type="text" placeholder="(optional) Enter a short description." />,
            )}
          </Form.Item>
        </Form>
      </Tool>
    );
  }
}

export default Form.create()(ConnectionToolEditor);

/*
<Card
        bordered={false}
        className="vb-toolbox_content_card"
        title={!isNew ? 'Editing Connection' : 'New Connection'}
        extra={
          !isNew &&
          <Popconfirm
            title="Are you sure delete this connection?"
            onConfirm={onDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button
              shape="circle"
              icon="delete"
              size="small"
              ghost
              type="danger"
            />
          </Popconfirm>
        }
        actions={[
          <Button ghost type="dashed" onClick={onCancel}>Cancel</Button>,
          <Button style={{ marginLeft: '8px' }} type="primary" onClick={this.handleSubmit}>Save</Button>,
        ]}
        bodyStyle={{ padding: '0' }}
      >
      </Card>
 */
